import { Link } from '@tanstack/react-router'
import { CloudOff } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function LoadError({ title, onRetry, backToList = false }: { title: string; onRetry: () => void; backToList?: boolean }) {
  return (
    <div className="flex flex-col items-center justify-center px-8 py-16 text-center">
      <CloudOff className="mb-4 h-8 w-8 text-muted-foreground" />
      <h2 className="text-sm font-medium text-foreground">{title}</h2>
      <p className="mt-1.5 text-xs text-muted-foreground">Something went wrong. Try again in a moment.</p>
      <div className="mt-6 flex items-center gap-3">
        <Button size="sm" onClick={onRetry}>
          Try again
        </Button>
        {backToList && (
          <Link to={'/clients' as never} className="text-sm font-medium text-etn-accent">
            Back to Client dashboards
          </Link>
        )}
      </div>
    </div>
  )
}
